module.exports = __webpack_public_path__ + "static/img/index-banner2.32c38ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-banner2.jpg
// module id = +YFB
// module chunks = 0